/**
 * Barras CSS simples (sin librería). Valores null → vacío.
 * @param {{ rows: Array<{ label:string, value:number|null }>, emptyText?: string }} props
 */
import { formatAnalyticsNumber } from '../utils/format-number.js';

export default function SimpleBarList({ rows, emptyText = 'Sin datos para graficar.' }) {
  const list = (Array.isArray(rows) ? rows : []).filter((r) => r && r.label);
  const nums = list
    .map((r) => r.value)
    .filter((v) => v != null && v !== '')
    .map((v) => Number(v))
    .filter((n) => Number.isFinite(n) && n >= 0);
  if (!list.length) {
    return <p className="analytics-empty">{emptyText}</p>;
  }
  if (!nums.length) {
    return <p className="analytics-empty">{emptyText}</p>;
  }
  const max = Math.max(...nums, 1);
  return (
    <div className="analytics-bar-list" role="img" aria-label="Gráfico de barras">
      {list.map((r) => {
        const raw = r.value;
        const missing = raw == null || raw === '';
        const v = Number(raw);
        const ok = !missing && Number.isFinite(v);
        const pct = ok ? Math.round((v / max) * 100) : 0;
        return (
          <div key={r.label} className="analytics-bar-row">
            <span className="analytics-bar-label">{r.label}</span>
            <div className="analytics-bar-track">
              {ok ? (
                <div className="analytics-bar-fill" style={{ width: pct + '%' }} />
              ) : (
                <span className="analytics-bar-nodata">Sin datos</span>
              )}
            </div>
            <span className="analytics-bar-value num">{ok ? formatAnalyticsNumber(v) : '—'}</span>
          </div>
        );
      })}
    </div>
  );
}
